import { createSelector, createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { generateSearchParams } from 'utils/helpers/fetch';

const initialState = {
  error: '',
  pending: false,
  ptoNumbersList: [],
};

const reducers = {
  fetchPtoNumbersError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchPtoNumbersPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchPtoNumbersSuccess(state, { payload }) {
    return R.assoc('ptoNumbersList', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'ptoNumbers',
  reducers,
});

const { fetchPtoNumbersPending, fetchPtoNumbersSuccess, fetchPtoNumbersError } = actions;

// Selectors
export const getPtoNumbers = state => state.pto.ptoNumbers.ptoNumbersList;
export const getPtoNumbersPending = state => state.pto.ptoNumbers.pending;
export const getPtoNumbersError = state => state.pto.ptoNumbers.error;

export const getPtoNumbersOptions = createSelector(getPtoNumbers, ptoNumbers =>
  ptoNumbers.map(ptoNum => ({
    label: `${ptoNum}`,
    value: `${ptoNum}`,
  }))
);

// Actions
let fetchController;
export function fetchPtoNumbers() {
  return (dispatch, getState) => {
    const { currentAffiliate } = getState().pto.searchPtos;
    const formattedAffiliate = currentAffiliate
      ? {
          affiliate: {
            companyCustomerIdName: currentAffiliate.customerIdName,
            dataCompanyId: currentAffiliate.dataCompanyId,
          },
        }
      : null;
    const paramString = qs.stringify(
      generateSearchParams(getState().pto.searchPtoFilters, formattedAffiliate),
      { allowDots: true, encode: false }
    );
    dispatch(fetchPtoNumbersPending(true));
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();
    const { signal } = fetchController;
    http
      .get(`/product-transfer-orders/get-unique-numbers-list?${paramString}`, { signal })
      .then(res => {
        dispatch(fetchPtoNumbersError(''));
        dispatch(fetchPtoNumbersSuccess(res.data));
        dispatch(fetchPtoNumbersPending(false));
      });
  };
}

export default reducer;
